import { render, staticRenderFns } from "./sso-account.vue?vue&type=template&id=bb848484&"
import script from "./sso-account.vue?vue&type=script&lang=js&"
export * from "./sso-account.vue?vue&type=script&lang=js&"
import style0 from "./sso-account.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports